
<template>
    <nav class="navbar navbar-expand-md navbar-light justify-content-end justify-content-md-between w-100 mx-2">
        <button class="btn btn-icon navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <img src="@/assets/svg/collapse-menu.svg" alt="Align Justify" width="14" height="14" />
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <div class="profile-tabs d-flex justify-content-end flex-wrap mt-1 mt-md-0">
                <ul class="nav nav-pills mb-0">
                    <li 
                        v-for="(tab, index) in tabs" :key="tab.slug"
                        :tab="tab" :index="index"
                        class="nav-item"
                    >
                        <a 
                            :href="`#${tab.slug}`" class="nav-link"
                            :class="activeTab === tab.slug && 'fw-bold active'"
                            @click.prevent="onHandleClick(tab)"
                        >
                            <span class="d-md-block">{{ tab.title }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script setup>
import { useRoute } from 'vue-router';

const props = defineProps({
    tabs: Array,
    activeTab: [String, null],
    activeComponent:  [Object, Function, String, null],
});

const emit = defineEmits(['update:activeTab', 'update:activeComponent', 'clickToSubmit']);
const route = useRoute();

const onHandleClick = (tab) => {

    if(! route.query.general_id && tab.slug === 'billing') {
        return checkIfDefaultTreatmentPlan();
    }

    emit('update:activeTab', tab.slug);
    emit('update:activeComponent', tab.component);
    window.location.hash = tab.slug;
}

const checkIfDefaultTreatmentPlan = () => {
    const confirmed = window.confirm('If you switch tabs, Treatment will be saved as default. Are you sure you want to switch tabs?');
    if (!confirmed) return false;
    emit('clickToSubmit');
    return true;
}

</script>

<style scoped>
.nav-link{
    padding: 8px 6px;
}
.nav-pills .nav-link, .nav-tabs .nav-link {
    justify-content: start !important;
}
.nav-link {
    border: 1px solid #7367f0;
    margin-left: 5px;
}
.navbar-light {
    background: transparent !important;
}
@media only screen and (min-device-width: 800px) and (max-device-width: 990px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .nav-pills .nav-link {
      padding: 0.786rem 0.5rem !important;
  }
}

@media (min-width: 768px){
    .profile-header-nav .profile-tabs {
        margin-left: 0 !important;
    }
}

</style>